import React, {useRef} from 'react';
import {RedirectWithParams} from 'epic-diesel-common';
import WithApplicationView, {WithApplicationViewProps} from '../../hocs/WithApplicationView';
import SignUp from './SignUp';
import {canSignUp, canReApply} from '../../utils/ValidationUtils';
import {PreSignUp, ApplicationHeader, ApplicationForm} from '../../components';

const SignUpView = (props: WithApplicationViewProps) => {
    const signupRef = useRef();

    const {affiliateAccount} = props.influencerState || {};
    const {status} = affiliateAccount || {};
    const {accountInfo} = props.userState || {};
    const {isLoggedIn} = accountInfo;

    // If we're not even logged in, we need to go back to the main page
    if (!isLoggedIn) {
        return <RedirectWithParams to="overview" />;
    }

    // approved applicants redirect to dashboard
    if (status === 'ACTIVE') {
        return <RedirectWithParams to="dashboard" />;
    }

    const configState = props.configState;
    const {talonFlowID, enableTalon, enableV2Signup, enableCodeSelfService} = configState || {};

    // block user from re-applying if on cooldown
    if (!enableV2Signup || !canReApply(affiliateAccount)) {
        return <RedirectWithParams to="overview" />;
    }

    const _props = {
        ...props,
        ref: signupRef,
        children: SignUp,
        enableTalon,
        flow: talonFlowID,
        configState,
        disclaimerEnabled: enableCodeSelfService ? false : true
    };

    return (
        <>
            <ApplicationHeader userState={props.userState} />
            {!canSignUp(accountInfo) ? (
                <PreSignUp
                    messages={props.messages}
                    userState={props.userState}
                    influencerState={props.influencerState}
                    resendEmailVerification={props.resendEmailVerification}
                    checkSignupRequirementsMet={props.checkSignupRequirementsMet}
                />
            ) : (
                <ApplicationForm {..._props} />
            )}
        </>
    );
};

export default WithApplicationView(SignUpView);
